
class EnvHelper {
    public static isDevelopmentQa = () => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'CATTLE';
        } else if (ENV_NAME === 'qa') {
            return 'CATTLE QA';
        } else if (ENV_NAME === 'dev') {
            return 'CATTLE DEV';
        } else {
            return 'CATTLE ENV NOT FOUND';
        }
    };
}

export default EnvHelper;